var exports = {
  "kL": "xdbfd91f1--87effc--container",
  "jq": "xdbfd91f1--87effc--no_village_price",
  "VG": "xdbfd91f1--87effc--min_max_prices",
  "nh": "xdbfd91f1--87effc--min_max_prices_item",
  "vT": "xdbfd91f1--87effc--preposition",
  "Gl": "xdbfd91f1--87effc--currency",
};

module.exports = exports;
